import React, { FC, useEffect } from "react";
import { useImmer } from "use-immer";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { ConfigurationDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { usePatchConfigurations } from "../../api/configurations/patch-configurations";
import { useGetOrg } from "../../api/organizations/get-organization";
import Loading from "../../utils/Loading";

import { ConfigurationInput } from "./AdminSettings/AdvancedSettings/ConfigurationInputs";
import {
  getNewModifiedConfigs,
  onConfigChange,
  sortSettings,
} from "./Utils/Utils";

const PREFIX = "ScopeSettings";

const classes = {
  container: `${PREFIX}-container`,
  sectionLabel: `${PREFIX}-sectionLabel`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.container}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },

  [`& .${classes.sectionLabel}`]: {
    marginTop: 5,
  },
}));

export const ScopeSettings: FC = () => {
  const organization = useGetOrg();
  const [modifiedConfigs, setModifiedConfigs] = useImmer<ConfigurationDto[]>(
    []
  );
  const [settingsState, setSettingsState] = useImmer<ConfigurationDto[]>([]);

  const mutateConfigurations = usePatchConfigurations();

  useEffect(() => {
    const newSettingsState = organization.data.org.configurations.filter(
      (config) => config.topic === "WEB_UI_SCOPE"
    );

    setSettingsState(sortSettings(newSettingsState));
    setModifiedConfigs(
      getNewModifiedConfigs(
        newSettingsState,
        organization.data.org.configurations
      )
    );
  }, [organization.data.org.configurations]);

  useEffect(() => {
    if (settingsState) {
      setModifiedConfigs(
        getNewModifiedConfigs(
          settingsState,
          organization.data.org.configurations
        )
      );
    }
  }, [organization.data.org.configurations, settingsState]);

  if (settingsState) {
    return (
      <Root>
        <IgTypography className={classes.sectionLabel} variant="h6">
          Organization Permissions
        </IgTypography>
        <Grid item container direction={"column"} rowSpacing={0.5}>
          {sortSettings(settingsState).map(
            (config: ConfigurationDto, index: number) =>
              config.key === "shipping_progress_bar_config" ? null : (
                <ConfigurationInput
                  key={config.key}
                  config={config}
                  onChange={(newValue: any) =>
                    onConfigChange(config.key, newValue, setSettingsState)
                  }
                />
              )
          )}
        </Grid>
        <Grid item textAlign={"end"}>
          <IgButton
            loading={mutateConfigurations.isPending}
            style={{ marginTop: 5 }}
            size="medium"
            variant={"contained"}
            onClick={() => {
              mutateConfigurations.mutate(modifiedConfigs || []);
            }}
          >
            Save Permissions
          </IgButton>
        </Grid>
      </Root>
    );
  }
  return <Loading />;
};
